// import React from 'react';

// const Modal = ({ isOpen, onClose, title, children }) => {
//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-[#252526] border border-[#3E3E42] rounded-lg p-6 w-full max-w-md">
//                 <div className="flex justify-between items-center mb-4">
//                     <h3 className="text-xl font-semibold text-[#CCCCCC]">{title}</h3>
//                     <button
//                         onClick={onClose}
//                         className="text-[#CCCCCC] hover:text-white"
//                     >
//                         ✕
//                     </button>
//                 </div>
//                 {children}
//             </div>
//         </div>
//     );
// };

// export default Modal; 

const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
            <div className="bg-[#252526] border border-[#3E3E42] rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6">
                <div className="flex justify-between items-center mb-4 sticky top-0 bg-[#252526] z-10">
                    <h3 className="text-xl p-1 font-semibold text-[#CCCCCC]">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-[#CCCCCC] hover:text-white"
                    >
                        ✕
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
};

export default Modal;